import { render, staticRenderFns } from "./ExtBox.vue?vue&type=template&id=14fa01ec&scoped=true"
import script from "./ExtBox.vue?vue&type=script&lang=js"
export * from "./ExtBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa01ec",
  null
  
)

export default component.exports